import { Box, styled } from '@mui/material';

export const AutoSizeTextFieldContainer = styled(Box, {
  shouldForwardProp: (prop: string) => !['isError'].includes(prop),
})<{
  isError?: boolean;
}>(({ theme, isError }) => ({
  width: '100%',
  'input::placeholder': {
    color: theme.palette.case.neutral.n500,
  },
  '.auto_size_text_field': {
    input: {
      border: 'none',
      borderRadius: '5px',
      fontFamily: 'Archivo',
      color: theme.palette.case.neutral.n900,
      backgroundColor: 'transparent',
      maxWidth: '100%',
      padding: '6px',
      outline: 'none',
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: '500',
      borderColor: '6px !important',
      transition: 'background-color 0.2s ease',
      '&:hover': {
        backgroundColor: isError ? theme.palette.case.red.r100 : theme.palette.case.neutral.n75,
      },
      '&:focus': {
        backgroundColor: isError ? theme.palette.case.red.r100 : theme.palette.case.neutral.n100,
      },
      '&:disabled': {
        WebkitTextFillColor: theme.palette.case.neutral.n400,
        backgroundColor: 'transparent',
      },
      ...(isError && {
        backgroundColor: `${theme.palette.case.red.r100} !important`,
      }),
    },
  },
}));
